import { createNanoEvents } from "nanoevents";

export const nanoEmitter = createNanoEvents();
